module.exports = __webpack_public_path__ + "static/media/LGCP02.fbea691d.jpg";